import React from "react";
import "./Spinner.css";

interface SpinnerProps {
  /** Diameter in px (default 32). */
  size?: number;
  /** Extra class on the centering wrapper. */
  className?: string;
  /** Accessible label for screen readers. */
  label?: string;
  /** Render just the spinner with no centering wrapper/padding. */
  inline?: boolean;
}

/**
 * Reusable spinning blue loading indicator (brand blue #004d9e), matching the
 * app's global loader. Use this instead of "Loading…" text.
 */
const Spinner: React.FC<SpinnerProps> = ({
  size = 32,
  className = "",
  label = "Loading",
  inline = false,
}) => {
  const ring = (
    <span
      className="csm-spinner"
      role="status"
      aria-label={label}
      style={{
        width: size,
        height: size,
        borderWidth: Math.max(2, Math.round(size / 12)),
      }}
    />
  );

  if (inline) return ring;
  return <div className={`csm-spinner-wrap ${className}`.trim()}>{ring}</div>;
};

export default Spinner;
